import React from 'react'
import Asset from '../../../../../../../../../requests/apa/Asset'
import './_styles.scss'
import Utils from '../../../../../../../../../utils/Utils'

/**
 * SquadPlayerCard
 * Tarjeta de jugador para la sección "Plantilla".
 * Diseño sin sustitución: Figma node 144:32768
 * Diseño con sustitución:  Figma node 144:33151
 * (1rem = 15px)
 *
 * Props:
 *  playerName   {string}      — nombre del jugador
 *  birthDate    {string}      — fecha de nacimiento + edad, ej: "27 Jun 2004 (21 años)"
 *  jerseyNumber {number|string} — dorsal
 *  photoUrl     {string}      — URL de la foto
 *  substitution {object}      — opcional. Si está presente activa la sección inferior.
 *    substitution.outDate {string} — fecha en que salió del campo (flecha roja ↓)
 *    substitution.inDate  {string} — fecha en que entró al campo (flecha verde ↑)
 */
var ARROW_DOWN_SRC = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='24' viewBox='0 0 21 24' fill='none'%3E%3Crect x='8.5' y='0' width='4' height='14' rx='1' fill='%23e74c3c'/%3E%3Cpath d='M0.5 13L10.5 24L20.5 13H0.5Z' fill='%23e74c3c'/%3E%3C/svg%3E"
var ARROW_UP_SRC   = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='24' viewBox='0 0 21 24' fill='none'%3E%3Cpath d='M0.5 11L10.5 0L20.5 11H0.5Z' fill='%232ecc71'/%3E%3Crect x='8.5' y='10' width='4' height='14' rx='1' fill='%232ecc71'/%3E%3C/svg%3E"

function ArrowDown () {
  const iconSubstitutionOut = Asset.get('eventodeportivo_icono_sale');
  return <img className='squad-player-card__arrow-icon' src={iconSubstitutionOut} width='24' height='24' alt='' />
}

function ArrowUp () {
  const iconSubstitutionIn = Asset.get('eventodeportivo_icono_entra');
  return <img className='squad-player-card__arrow-icon' src={iconSubstitutionIn} width='24' height='24' alt='' />
}

function SquadPlayerCard (props) {
  var playerName = props.playerName
  var birthDate = props.birthDate
  var age = props.age
  var displayInfoBirthDate = props.displayInfoBirthDate
  var jerseyNumber = props.jerseyNumber
  var jerseyNumberStr = jerseyNumber != null ? `# ${jerseyNumber}` : ''
  var photoUrl = props.photoUrl
  var substitution = props.substitution
  var substitutionMovements = substitution ? substitution.filter(function (m) {
    return m.type === 'SUBSTITUTION_OUT' || m.type === 'SUBSTITUTION_IN'
  }) : []
  var hasSubstitutions = substitutionMovements.length > 0
  var displayDateToSubstitutions = props.displayDateToSubstitutions

  return (
    <div className={'squad-player-card' + (hasSubstitutions ? ' squad-player-card--substitution' : '')}>
      <div className='squad-player-card__bg-top' />
      {hasSubstitutions && <div className='squad-player-card__bg-bottom' />}
      <img
        className='squad-player-card__photo'
        src={photoUrl}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = Asset.get('eventodeportivo_placeholder_imagen_jugador_2');
        }}
        alt={playerName}
      />
      <div className='squad-player-card__separator' />
      <p className='squad-player-card__name'>{Utils.cutPlayerString(playerName, 20)}</p>
      <p className='squad-player-card__birth'>{Utils.cutPlayerString(displayInfoBirthDate, 21)}</p>
      {jerseyNumber && <p className='squad-player-card__number'>{Utils.cutPlayerString(jerseyNumberStr, 5)}</p>}
      {hasSubstitutions && (
        <div className='squad-player-card__substitution'>
          {substitutionMovements.map((movement, index) => (
            <div key={index} className='squad-player-card__sub-item'>
              {movement.type === 'SUBSTITUTION_OUT' ? <ArrowDown /> : <ArrowUp />}
              <span className='squad-player-card__sub-date'>{displayDateToSubstitutions && displayDateToSubstitutions}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default SquadPlayerCard



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/SquadPlayerCard/index.jsx